<template>
    <div class="page" id="page_achievements">
        <header>
            <h2 >Our Achievements</h2>
        
        </header>
        <div class="content-container"> 
        <ul>
            <li><img src="images/logo-ge.gif" width="" height="" alt="Great Eastern" data-aos="fade-left"/></li>
            <li><img src="images/logo-ntuc.gif" width="" height="" alt="NTUC"  data-aos="fade-right"/></li>
            <li><img src="images/logo-schroders.gif" width="" height="" alt="Schroders"  data-aos="fade-left"/></li>
            <li><img src="images/logo-huntsman.gif" width="" height="" alt="Huntsman" data-aos="fade-right"/></li>
            <li><img src="images/logo-munich-re.gif" width="" height="" alt="Munich Re" data-aos="fade-left"/></li>
        </ul>
        
        <img src="images/bubbles.png" alt="Bubbles" width="900" height="" class="bubbles " data-aos="fade-up" data-aos-duration="1500"/>
        <img src="images/achievements01.jpg" alt="Achievements 01" width="900" height="599" class="mobile-hide" />
        
        <img src="images/bubbles.png" alt="Bubbles" width="900" height="" class="bubbles2" data-aos="fade-up" data-aos-duration="1500"/>
        <img src="images/achievements02.jpg" alt="Achievements 02" width="900" height="621" class="mobile-hide" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Achievements'
}
</script>

<style lang="less" scoped>
#page_achievements {
    background: #ffe730;
    overflow: hidden;
    min-height: 300px;
    position: relative;

    header {
        border-top: 10px solid #ffe730;
        border-bottom: 10px solid #ffe730;
        background: none;
        padding-bottom: 0;

        h2 {
            background: url(../../public/images/glory-title-bg.png) no-repeat center top;
            color: @txtColor;
            margin: 0;
            padding: 1.2em 0;
            text-align: center;
        }
    }

    .content-container {
        padding-top: 0;
    }

    li {
        
        list-style: none;
        margin: 100px auto;
        padding: 0;
        width: 70%;

        img {
            box-shadow: 0 0 20px 5px rgba(227,179,23,1);
            margin:0;
            padding: 0;
        }
    }

    .bubbles {
        left: 0;
        position: absolute;
        top: 300px;
        width: 100%;
        z-index: 10;
    }
    .bubbles2 {
        left: 0;
        position: absolute;
        top: 900px;
        width: 100%;
        z-index: 10;
    }
}

@media only screen and (min-width : 768px) {
    #page_achievements {
        li {
            width: 300px;
        }

        .bubbles {
            opacity: 0.2;
        }
        .bubbles2 {
            display: none;
        }
    }
}
</style>